import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiSend } from 'react-icons/fi';
import Whatsapp from '../../../../../../components/Whatsapp';
import { authTitle } from '../../../../../../config';
import { FaMailBulk, FaPaperPlane } from 'react-icons/fa';
import { useLoading } from 'src/hooks/LoadingHook';
import { useModal } from 'src/hooks/Modal';
import sleep from 'src/utils/sleep';

interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ContactModule({

  lineData,

}: ICreateModule): JSX.Element {

  const { addLoading, removeLoading } = useLoading();
  const { addModal } = useModal();
  const { addToast } = useToast();


  const sendMail = async () => {


    try {
      await api.post(`/send-invitation-to-user/${lineData?.invitation_id}/${lineData?.user_hash}/yes`);

      addToast({ title: `1/ 1 - Enviado com sucesso`, type: 'success' });

    }
    catch (err) {

      addToast({ title: `1/ 1 - ${err?.response?.data?.message || 'Erro ao enviar'} `, type: 'error' })
    }

    return;

  }



  const sendMailCheck = () => {

    addModal({
      title: '', theme: 'whiteModalMedium', content: <>
        <h2 style={{ color: '#333', fontSize: '#333', width: '100%', textAlign: 'center' }}>Confirmar envio?</h2>
        <button className='greenButton2' style={{ margin: '10px auto' }} type='button' onClick={() => { sendMail() }}>Enviar</button>

      </>
    })

  }



  const moduleUpdate = (data: Record<string, any>): JSX.Element => (
    <button className='lineIcon' title='Reenviar convite' onClick={() => { sendMailCheck() }}><FaPaperPlane /></button>
  );

  return moduleUpdate(lineData);
}
